import type { RegistrationDraft } from "./auth_api";

export type AuthScreen = "login" | "registration";

export type FlowScreen = AuthScreen | "code" | "recovery" | "recovery-code" | "new-password";

/** Everything the modal holds between screens — enough to reopen it where the reader left. */
export type AuthFlow = {
	screen: FlowScreen;
	draft: RegistrationDraft;
	recovery: { email: string; token: string };
};

export type SavedFlow = { flow: AuthFlow; at: number };

/** A code lives five minutes on the server; ten covers the wait without bringing back a dead one. */
export const RESUME_TTL_MS = 10 * 60 * 1000;

// Screens reached only after the server sent something the reader is now waiting on.
const RESUMABLE: FlowScreen[] = ["code", "recovery-code", "new-password"];

const EMPTY_DRAFT: RegistrationDraft = {
	name: "",
	secondName: "",
	email: "",
	password: "",
	confirmPassword: "",
	country: "",
	city: "",
	countryId: null,
	cityId: null,
};

export const initialFlow = (screen: AuthScreen): AuthFlow => ({
	screen,
	draft: EMPTY_DRAFT,
	recovery: { email: "", token: "" },
});

/** `flow` is null when the modal closed because the reader signed in. */
export const rememberOnClose = (flow: AuthFlow | null, now: number): SavedFlow | null =>
	flow && RESUMABLE.includes(flow.screen) ? { flow, at: now } : null;

export const resumeFlow = (saved: SavedFlow | null, now: number): AuthFlow | null =>
	saved && now - saved.at < RESUME_TTL_MS ? saved.flow : null;
